import core from '@/helpers/client'
import store from '@/state/store'
const catalogService = {
  async headCatalogMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/catalogs`,
      params
    )
    return result
  },
  async getCatalogMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/catalogs`,
      params
    )
    return result
  },
  async GetCatalogProductsByIdAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/catalogs/${id}/products`,
      params
    )
    return result
  },
  async GetCatalogProductsByIdLoadingAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/catalogs/${id}/products`,
      params,
      {},
      true
    )
    return result
  },
  async getCatalogMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/catalogs/${id}`
    )
    return result
  },
  async createCatalogMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/catalogs`,
      model
    )
    return result
  },
  async updateCatalogMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/catalogs/${id}`,
      model
    )
    return result
  },
  async deleteCatalogMasterByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/catalogs/delete/${id}`
    )
    return result
  },
}
export default catalogService
